import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Cookies from 'js-cookie'
import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use( CKEditor );

Vue.use(ElementUI);

Vue.config.productionTip = false

if (process.env.NODE_ENV == 'development'){
  Vue.prototype.apiUrl = 'http://api.mall.lypinyue.cyy';
  Vue.prototype.domainUrl = 'http://localhost:8084'
  Vue.prototype.mobileDomain = 'http://m.mall.lypinyue.cyy'
  Vue.prototype.loginDomain = 'http://localhost:8081'
  Vue.prototype.siteDomain = 'jz.lypinyue.cyy';
  Vue.prototype.pcLoginUrl = 'http://www.c2cmall.cyy/?app=member&act=login&ret_url='+encodeURIComponent(location.href);
  axios.defaults.baseURL = 'http://api.mall.lypinyue.cyy'
}else {
  Vue.prototype.apiUrl = 'https://api.shop.shangduoke.com';
  Vue.prototype.pcDomain = 'http://shop.shangduoke.com';
  Vue.prototype.pcLoginUrl = 'http://shop.shangduoke.com/?app=member&act=login&ret_url='+encodeURIComponent(location.href);
  Vue.prototype.domainUrl = 'http://admin.jz.shangduoke.com'
  Vue.prototype.mobileDomain = 'https://m.mall.lypinyue.com'
  Vue.prototype.loginDomain = 'http://login.shangduoke.com'
  axios.defaults.baseURL = 'https://api.shop.shangduoke.com'
  Vue.prototype.siteDomain = 'jz.shangduoke.com';
  Vue.prototype.cookieDomain = 'shangduoke.com'
}

Vue.prototype.$http = axios
Vue.prototype.$http.defaults.withCredentials = true;

//http request 拦截器
axios.interceptors.request.use(
    config => {
      if (Cookies.get('access_token')) {
        var access_token = Cookies.get('access_token')// 判断是否存在token，如果存在的话，则每个http header都加上token
        var password = ''
        //config.headers.Authorization = 'Basic ' + Base64.encode(access_token+':'+password);
        config.headers.Authorization = 'Bearer ' + access_token;
      }
      return config;
    },
    err => {
      return Promise.reject(err);
    });
var _this = this
// http response 拦截器
axios.interceptors.response.use(
    response => {

      return response;
    },
    error => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 返回 401 清除token信息并跳转到登录页面
            //this.$store.commit('setToken',{access_token:null});
            //sessionStorage.removeItem('access_token')
            //console.log(Vue.prototype.loginDomain)
            var screenWidth = window.screen.width;
            if (screenWidth > 800){
              //location.href = Vue.prototype.pcLoginUrl;
              this.$router.push('/login')
            }else {
              //location.href = Vue.prototype.loginDomain+'/jz/#/login?redirectUrl='+encodeURIComponent(location.href)
            }
        }
      }
      return Promise.reject(error)   // 返回接口返回的错误信息
    });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
